<!-- =========================================================================================
  File Name: UserEditTabInformation.vue
  Description: User Edit Information Tab content
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
	<div slot="no-body">
		<vs-navbar
			v-model="activeItem"
			color="primary"
			text-color="rgba(255,255,255,.6)"
			active-text-color="rgba(255,255,255,1)"
			class="myNavbar cursor-pointer"
		>
			<vs-navbar-item :index="0">
				<a :class="activeItem === 0 ? 'font-bold' : 'font-semibold'">
					{{ $t("TimeWindow.DayOfWeek") }}
				</a>
			</vs-navbar-item>
			<vs-navbar-item :index="1">
				<a :class="activeItem === 1 ? 'font-bold' : 'font-semibold'">
					{{ $t("TimeWindow.DayOfMonth") }}
				</a>
			</vs-navbar-item>
			<vs-navbar-item :index="2">
				<a :class="activeItem === 2 ? 'font-bold' : 'font-semibold'">
					{{ $t("TimeWindow.Month") }}
				</a>
			</vs-navbar-item>
			<vs-navbar-item :index="3">
				<a :class="activeItem === 3 ? 'font-bold' : 'font-semibold'">
					{{ $t("TimeWindow.Hours") }}
				</a>
			</vs-navbar-item>
			<vs-navbar-item :index="4">
				<a :class="activeItem === 4 ? 'font-bold' : 'font-semibold'">
					{{ $t("TimeWindow.Minutes") }}
				</a>
			</vs-navbar-item>
		</vs-navbar>
		<transition name="fade">
			<div class="tab-text" v-show="activeItem === 0">
				<day-week @resultDayWeekEmit="resultDayWeek" />
			</div>
		</transition>
		<transition name="fade">
			<div class="tab-text" v-show="activeItem === 1">
				<day-month @resultDayMonthEmit="resultDayMonth" />
			</div>
		</transition>
		<transition name="fade">
			<div class="tab-text" v-show="activeItem === 2">
				<Monthly @resultMonthEmit="resultMonth" />
			</div>
		</transition>
		<transition name="fade">
			<div class="tab-text" v-show="activeItem === 3">
				<hourly @resultHourEmit="resultHour" />
			</div>
		</transition>
		<transition name="fade">
			<div class="tab-text" v-show="activeItem === 4">
				<minute @resultMinuteEmit="resultMinute" />
			</div>
		</transition>
	</div>
</template>

<script>
import moduleBreaks from "@/store/breaks/moduleBreaks.js";
import {generalPurposeMixin} from "@/mixins/generalPurposeMixin.js";
import {FormWizard, TabContent} from "vue-form-wizard";
import "vue-form-wizard/dist/vue-form-wizard.min.css";

export default {
	name: "RepeatCron",
	mixins: [generalPurposeMixin],
	components: {
		FormWizard,
		TabContent,
	},
	data() {
		return {
			cronDayWeek: "*",
			cronDayMonth: "*",
			cronMonth: "*",
			cronHour: "0",
			cronMinute: "0",
			activeItem: 0,
		};
	},
	created() {
		if (!moduleBreaks.isRegistered) {
			this.$store.registerModule("moduleBreaks", moduleBreaks);
			moduleBreaks.isRegistered = true;
		}
	},
	mounted() {
		this.updateCronExpression();
	},
	computed: {
		cronExpression() {
			return `${this.cronMinute} ${this.cronHour} ${this.cronDayMonth} ${this.cronMonth} ${this.cronDayWeek}`;
		},
	},
	methods: {
		openLoading() {
			this.$vs.loading();
		},
		closeLoading() {
			this.$vs.loading.close();
		},
		updateCronValue(field, value) {
			this[field] = value;
		},
		resultDayMonth(val) {
			this.updateCronExpression();
			this.updateCronValue("cronDayMonth", val);
		},
		resultDayWeek(val) {
			this.updateCronExpression();
			this.updateCronValue("cronDayWeek", val);
		},
		resultMonth(val) {
			this.updateCronExpression();
			this.updateCronValue("cronMonth", val);
		},
		resultHour(val) {
			this.updateCronExpression();
			this.updateCronValue("cronHour", val);
		},
		resultMinute(val) {
			this.updateCronExpression();
			this.updateCronValue("cronMinute", val);
		},
		addDaysToDate(stringDate, dayNums) {
			const date = new Date(stringDate);
			return date.setDate(date.getDate() + dayNums);
		},
		updateCronExpression() {
			this.$emit("updateCronExpressionEmit", this.cronExpression);
		},
	},
};
</script>
<style lang="scss" scoped>
.vs-navbar-gradient .vs-navbar-item-primary.is-active-item {
	border-radius: 6px;
	color: #fff !important;
	background: rgba(var(--vs-primary), 1);
}

.vs-navbar {
	-webkit-box-shadow: none;
	box-shadow: none;
}

.vs-navbar-gradient {
	border: 1px solid rgba(0, 0, 0, 0.05);
}

.vs-navbar-gradient .vs-navbar--item {
	border-left: 1px solid rgba(0, 0, 0, 0.05);
}
</style>
